import { Routes, Route, Navigate } from 'react-router-dom';
import Login from '../components/Login';
import AppLayout from '../components/AppLayout';
import HomePage from '../views/HomePage';
import { AuthData, ManualItem } from '../types';
import ManualViewerPage from '../views/ManualViewerPage';

interface Props {
  manualItems: ManualItem[];
  loginData: null | AuthData;
  onAddOrEditManual: (data: any, mode: "add" | "edit") => {};
  setLoginData: (data: AuthData | null) => void
}

const AppRoutes = ({loginData, manualItems, onAddOrEditManual, setLoginData}: Props) => {
  return (
    <Routes>
      <Route path="/login" element={<Login loginData={loginData} setLoginData={setLoginData} />} />
      <Route path="/" element={<AppLayout loginData={loginData} manualItems={manualItems} />}>
        <Route
            index
            element={
              <HomePage
                  manualItems={manualItems}
                  loginData={loginData}
                  onAddOrEditManual={onAddOrEditManual}
              />
            }
        />
        <Route 
            path="manuals/:id" 
            element={
                <ManualViewerPage 
                    loginData={loginData}
                    manualItems={manualItems}
                />
            }
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;